// Module
var code = "<input ng-class=\"className\" id=\"{{ id }}\" />\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/date-range-picker/date-range-picker.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;